<script setup lang="ts">
/** Shown under the list options only while a tag filter is on: which label, and a way out. */
import { computed } from 'vue'
import { useCollab } from '../../stores/collab'
import { useInbox } from '../../stores/inbox'
import Icon from '../ui/Icon.vue'

const collab = useCollab()
const inbox = useInbox()
const tag = computed(() => (inbox.tagFilter ? (collab.tagById.get(inbox.tagFilter) ?? null) : null))
</script>

<template>
  <div v-if="inbox.tagFilter" class="tfc" role="status">
    <Icon name="tag" />
    <span>แสดงเฉพาะลูกค้าที่มีแท็ก</span>
    <span class="tg" :class="'tg-' + (tag?.tone ?? 'neutral')">{{ tag?.name ?? 'แท็กที่ถูกลบ' }}</span>
    <span class="grow"></span>
    <button class="tfc-x" aria-label="เลิกกรองตามแท็ก" title="เลิกกรองตามแท็ก" @click="inbox.setTagFilter(null)">
      <Icon name="x" />
    </button>
  </div>
</template>

<style scoped>
.tfc {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 4px 4px 4px 10px;
  border-radius: 8px;
  background: #f4f6f5;
  font-size: 12.5px;
  line-height: 19px;
  color: var(--mut);
  white-space: nowrap;
}
.tfc > :deep(.ic) {
  width: 14px;
  height: 14px;
}
.tfc-x {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: var(--mut);
}
.tfc-x:hover {
  background: #e3e9e6;
  color: var(--ink);
}
.tfc-x :deep(.ic) {
  width: 14px;
  height: 14px;
}
</style>
